export const generateThumbnail = (file) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    video.src = URL.createObjectURL(file);
    video.crossOrigin = "anonymous";
    video.muted = true;

    video.onloadeddata = () => {
      video.currentTime = 1; // capture frame at 1s
    };

    video.onseeked = () => {
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      canvas.toBlob(
        (blob) => {
          if (blob) {
            const thumbnail = new File([blob], "thumbnail.jpg", {
              type: "image/jpeg",
            });
            resolve(thumbnail);
          } else {
            reject("Thumbnail generation failed");
          }
        },
        "image/jpeg",
        0.8,
      );
    };

    video.onerror = (err) => reject(err);
  });
};
